export enum NEW_RELIC_EVENT {
  PRINT_BOARDING_PASS = 'print_boarding_pass',
  REPRINT_BOARDING_PASS = 'reprint_boarding_pass',
  PRINT_ERROR = 'print_error',
  SEAT_PURCHASE = 'seat_purchase',
  SEAT_ADD_TO_CART = 'seat_add_to_cart',
  SEAT_PURCHASE_ERROR = 'seat_purchase_error',
  LOOK_UP_PNR_SUCCESS = 'lookup_pnr_success',
  LOOK_UP_PNR_ERROR = 'lookup_pnr_error',
  LOOK_UP_PNR_NO_ITINERARY = 'lookup_pnr_no_itinerary',
  CARRY_ON_ADD_TO_CART = 'carry_on_add_to_cart',
  CARRY_ON_PAID = 'carry_on_paid',
  CARRY_ON_ERROR = 'carry_on_error',
  LOOK_UP_PNR_SCANNED_SUCCESS = 'lookup_pnr_scanned_success',
  LOOK_UP_PNR_SCANNED_ERROR = 'lookup_pnr_scanned_error',
  GET_RESERVATION = 'get_reservation',
  ELIGIBILITY = 'eligibility',
  BP_ELIGIBILITY = 'bording_pass_eligibility',
  PASSENGER_INFO = 'passenger_info',
  DOCUMENTS = 'documents',
  ADDON_5KG_ADD_TO_CART = 'addon_5kg_add_to_cart',
  ADDON_5KG_ERROR_ADD_TO_CART = 'addon_5kg_error_add_to_cart',
  ADDON_5KG_PURCHASE = 'addon_5kg_purchase',
  BOARDING_PASS_FALLBACK_ACTIVATED = 'boarding_pass_fallback_activated',
  BOARDING_PASS_SEGMENTS_FALLBACK = 'boarding_pass_segments_fallback',
  BOARDING_PASS_PASSENGERS_EMPTY = 'boarding_pass_passengers_empty',
  BOARDING_PASS_PASSENGER_ID_EMPTY = 'boarding_pass_passenger_id_empty',
  KIOSK_ADDRESS_AUTOCOMPLETE_INIT = 'kiosk_address_autocomplete_init',
  KIOSK_ADDRESS_AUTOCOMPLETE_RESEARCH_INIT = 'kiosk_address_autocomplete_research_init',
  KIOSK_ADDRESS_AUTOCOMPLETE_SELECTION = 'kiosk_address_autocomplete_selection',
  KIOSK_ADDRESS_SAVE = 'kiosk_address_save',
  KIOSK_ADDRESS_SCREEN_TIME = 'kiosk_address_screen_time',
  KIOSK_ADDRESS_AUTOCOMPLETE_SEARCH = 'kiosk_address_autocomplete_search',
  ADDON_5KG_PAID = 'addon_5kg_paid',
  ADDON_5KG_PAYMENT_ERROR = 'addon_5kg_payment_error',
  BAG_PRICE_ZERO_DETECTED = 'bag_price_zero_detected',
  KIOSK_CONNECTIVITY_RESTORED = 'kiosk_connectivity_restored',
  BAGS_DROPOFF_CONTINUE = 'bags_dropoff_continue',
  AVAILABLE_LUGGAGE = 'available_luggage',
  /** Maletas disponibles acumuladas de toda la reserva */
  AVAILABLE_LUGGAGE_RESERVATION = 'available_luggage_reservation',
  /** Lectura báscula/dimensionador SSBD (luggage-weighing-ssbd) */
  BAGS_SSBD_SCALE_READ = 'bags_ssbd_scale_read',
  /** Sobrepeso detectado en pesaje SSBD */
  BAGS_SSBD_OVERWEIGHT = 'bags_ssbd_overweight',
  /** Diferencia de peso en segunda lectura drop-off (CI-21926) */
  BAGS_SSBD_WEIGHT_DIFFERENCE = 'bags_ssbd_weight_difference',
  /** Lectura / búsqueda de etiqueta bag tag en print-bag-tag*/
  SEARCH_BAGTAG = 'search_bagtag',
  /** Resultado del pinpad en el flujo de pago SSBD (CI-22236) */
  PINPAD_RESPONSE = 'pinpad_response',
  SESSION_FLOW_DURATION = 'session_flow_duration',
  EXPERIENCE_POLL_RESPONSE = 'experience_poll_response',
  KIOSK_UNHANDLED_ERROR = 'KIOSK_UNHANDLED_ERROR',
  /** Paro de emergencia activado en SSBD */
  PRESSED_BUTTON_EMERGENCY = 'pressed_button_emergency',
  /** Métricas de dispositivos de hardware (CI-22198) */
  DEVICE_METRICS = 'device_metrics',
  /** Conteo de 302 (hardware error) antes de abrir el modal — trazabilidad BHS */
  SSBD_HARDWARE_ERROR_COUNTED = 'ssbd_hardware_error_counted',
  /** CI22795_DIAG — instrumentación TEMPORAL de diagnóstico del despacho al BHS (CI-22795). Eliminar al cerrar la HU. */
  CI22795_BHS_DISPATCH_DIAG = 'ci22795_bhs_dispatch_diag',
  /** Nivel bajo de papel en la impresora Bag Tag (CI-22506) */
  BAGTAG_PRINTER_MEDIA_LOW = 'bagtag_printer_media_low',
  /** Papel vacío en la impresora Bag Tag (CVT20-14314) */
  BAGTAG_PRINTER_MEDIA_EMPTY = 'bagtag_printer_media_empty',
  /** Nivel bajo de papel en la impresora de pases de abordar (CI-23161) */
  ATB_PRINTER_MEDIA_LOW = 'atb_printer_media_low',
  /** Papel vacío en la impresora de pases de abordar (CI-23161) */
  ATB_PRINTER_MEDIA_EMPTY = 'atb_printer_media_empty',
  /** Resultado del escaneo de boarding pass en scanner SSBD (CI-22201) */
  BOARDING_PASS_SCANNER_RESULT = 'boarding_pass_scanner_result',
  /** Resultado del escaneo de pasaporte en scanner SSBD (CI-22200) */
  PASSPORT_SCANNER_RESULT = 'passport_scanner_result',
  /** Ciclo de vida de la encuesta de satisfacción Qualtrics (CI-23287) */
  QUALTRICS_SURVEY = 'qualtrics_survey',
  /** Medio de entrada que originó la búsqueda de reserva */
  PNR_ENTRANCE_TYPE = 'pnr_entrance_type',
}
export enum DEVICE {
  BAGTAG_PRINTER = 'BAGTAG_PRINTER',
  ATB_PRINTER = 'ATB_PRINTER',
  PASSPORT_READER = 'PASSPORT_READER',
}

export enum DEVICE_ERROR_CODE {
  BAGTAG_FAILED = 'BAGTAG_FAILED',
  PECTAB_FAILED = 'PECTAB_FAILED',
  TICKET_FAILED = 'TICKET_FAILED',
  ATB_PECTAB_FAILED = 'ATB_PECTAB_FAILED',
}

export enum METRIC_NAME {
  KIOSK_AM = 'KIOSK_SSBD',
}

export enum CHECK_IN_TYPE {
  SEAMLESS = 'seamless',
  SABRE = 'sabre',
  UNKNOWN = 'unknown',
}

export enum CHECK_IN_LEGS_TYPE {
  ALL_SEAMLESS = 'all_seamless',
  ALL_SABRE = 'all_sabre',
  MIXED = 'mixed',
  UNKNOWN = 'unknown',
}

export enum RESPONSE_STATUS {
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum PAX_DOCUMENTS_STATUS {
  INCOMPLETE = 'incomplete',
  COMPLETED = 'completed',
  ENTER = 'enter',
  EXIT = 'exit',
}

export enum ADDRESS_STATUS {
  SUCCESS = 'success',
  FAILURE = 'failure',
}

export enum ADDRESS_CAPTURE_MODE {
  AUTOCOMPLETE = 'autocomplete',
  MANUAL = 'manual',
}

export enum SCAN_RESULT {
  SUCCESS = 'success',
  FAILURE = 'failure',
}

export enum SCAN_ERROR_TYPE {
  NONE = 'none',
  BARCODE_UNREADABLE = 'barcode_unreadable',
  FORMAT_NOT_RECOGNIZED = 'format_not_recognized',
  TIMEOUT = 'timeout',
  HARDWARE_ERROR = 'hardware_error',
}

export enum PASSPORT_SCAN_ERROR_TYPE {
  NONE = 'none',
  MRZ_UNREADABLE = 'mrz_unreadable',
  EMPTY_RESPONSE = 'empty_response',
  MALFORMED_TRACKS = 'malformed_tracks',
  DOCUMENT_DAMAGED = 'document_damaged',
  INCOMPLETE_INSERTION = 'incomplete_insertion',
  REMOVED_BEFORE_COMPLETION = 'removed_before_completion',
  MEDIA_ABSENT = 'media_absent',
  TIMEOUT = 'timeout',
  CANCELLED = 'cancelled',
  SEQUENCE_ERROR = 'sequence_error',
  JAMMED = 'jammed',
  FORMAT_ERROR = 'format_error',
  UNSUPPORTED_DOCUMENT = 'unsupported_document',
  HARDWARE_ERROR = 'hardware_error',
  SOFTWARE_ERROR = 'software_error',
  NOT_RESPONDING = 'not_responding',
  CONFIGURATION_ERROR = 'configuration_error',
  UNKNOWN_DEVICE_ERROR = 'unknown_device_error',
}

export enum PASSPORT_SCAN_ERROR_SOURCE {
  SDK_EVENT = 'sdk_event',
  STATUS_CODE = 'status_code',
  APP_VALIDATION = 'app_validation',
  APP_LIFECYCLE = 'app_lifecycle',
  LOCAL_TIMEOUT = 'local_timeout',
}

export enum PASSPORT_SCAN_PHASE {
  INSERTED = 'inserted',
  READING = 'reading',
  READING_RF_CHIP = 'reading_rf_chip',
  PARSING = 'parsing',
}

export enum PASSPORT_DATA_VALIDATION_STATUS {
  NOT_AVAILABLE = 'not_available',
  INVALID = 'invalid',
  MISSING_REQUIRED_FIELDS = 'missing_required_fields',
  COMPLETE = 'complete',
}

export enum PASSPORT_DOCUMENT_TYPE {
  PASSPORT = 'passport',
}

export enum BOARDING_PASS_TYPE {
  BARCODE = 'barcode',
  QR = 'qr',
}

export enum PNR_ENTRANCE_ORIGIN {
  BARCODE = 'barcode',
  PASSPORT = 'passport',
  PNR = 'PNR',
  TICKET = 'ticket',
  DESTINATION = 'destination',
}
